import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-regular-svg-icons';
import { faSpinner, faChevronRight, faGenderless, faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

export const icons = [faSpinner, faChevronRight, faGenderless, faCheckCircle, faTimesCircle, faInfoCircle];

library.add(icons);

export { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
